import { COMPANY_ROLES } from '@/types/roles';

/**
 * Workspace roles as the screens name them, most access first. The hint
 * describes the shipped default; a company may since have changed what a role
 * grants, which the Roles and permissions page shows.
 */
export const COMPANY_ROLE_OPTIONS = [
  {
    value: COMPANY_ROLES.COMPANY_ADMIN,
    label: 'Admin',
    hint: 'Full access, including billing and team',
  },
  {
    value: COMPANY_ROLES.HR,
    label: 'HR',
    hint: 'Publish internships, manage offers and analytics',
  },
  {
    value: COMPANY_ROLES.HIRING_MANAGER,
    label: 'Hiring manager',
    hint: 'Review candidates and make offers',
  },
  {
    value: COMPANY_ROLES.RECRUITER,
    label: 'Recruiter',
    hint: 'Create internships and screen candidates',
  },
];

const LABELS = Object.fromEntries(COMPANY_ROLE_OPTIONS.map((role) => [role.value, role.label]));

export function roleLabel(role) {
  return LABELS[role] ?? role;
}

/** Query keys, so a change on one screen refreshes the others. */
export const ACCESS_KEYS = {
  roles: ['company-roles'],
  mine: ['company-access'],
  member: (id) => ['company-member-permissions', id],
};

/** `[{ group, items: [catalogue entry] }]`, keeping the API's order. */
export function groupCatalogue(catalogue) {
  const groups = [];
  for (const entry of catalogue ?? []) {
    let group = groups.find((item) => item.group === entry.group);
    if (!group) {
      group = { group: entry.group, items: [] };
      groups.push(group);
    }
    group.items.push(entry);
  }
  return groups;
}

export function sameSet(a, b) {
  if (a.size !== b.size) return false;
  for (const item of a) if (!b.has(item)) return false;
  return true;
}
